/**
 * Global variable for booking. This uses to expose public methods.
 *
 * @since 1.15.79
 */
export const HookApi = () => {
	return window.wc_bookings.hooks;
};

export const BookingDisabledClass = 'disabled';

/**
 * Set the button disabled state.
 *
 * @param {Object}  button   jQuery button.
 * @param {boolean} disabled Whether to disable the button.
 * @return {void}
 */
export const SetButtonDisabled = ( button, disabled ) => {
	if ( disabled ) {
		button
			.addClass( BookingDisabledClass )
			.attr( 'aria-disabled', 'true' )
			.attr( 'disabled', 'disabled' );
	} else {
		button
			.removeClass( BookingDisabledClass )
			.removeAttr( 'aria-disabled' )
			.removeAttr( 'disabled' );
	}
};
